import React, { useState } from "react";
import classnames from "classnames";
import { usePagination, DOTS } from "./usePagination";
import "./pagination.css";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    if (currentPage !== 1) onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <ul className={`pagination  ${className}`}>
      <li
        className={classnames("page-item", {
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        <a className="page-link" href="#!">
          <span aria-hidden="true">&laquo;</span>
          <span className="sr-only">Previous</span>
        </a>
      </li>
      {paginationRange.map((pageNumber) => {
        if (pageNumber === DOTS) {
          return (
            <li key={pageNumber} className="page-item  dots">
              <a className="page-link" style={{ cursor: "default" }} href="#!">
                &#8230;
              </a>
            </li>
          );
        }

        return (
          <li
            className={classnames("page-item", {
              selected: pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
          >
            <a
              href="#!"
              className={classnames("page-link", {
                select: pageNumber === currentPage,
              })}
            >
              {pageNumber}
            </a>
          </li>
        );
      })}
      <li
        className={classnames("page-item", {
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        <a className="page-link" href="#!">
          <span aria-hidden="true">&raquo;</span>
          <span className="sr-only">Next</span>
        </a>
      </li>
    </ul>
  );
};

export default Pagination;
